import classnames from 'classnames';
import { map } from 'ramda';
import React, { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip } from '@wix/design-system';
import { LassoItem } from '../../../../../../components/common/Lasso/LassoItem';
import { MediaManagerSDKFolder } from '../../../../../../utils/media-manager-sdk';
import { isFile } from '../../../../../../utils/media-manager-sdk/items';
import styles from './FilesGallery.scss';
import { IOuter } from './FilesGallery.types';
import { ReadonlyFile } from './ReadonlyFile';
import { ReadonlyFolder } from './ReadonlyFolder';

const FilesGalleryItem = ({
  item,
  isItemSelected,
  isItemDisabled,
  onFileDoubleClick,
  onFolderDoubleClick,
  onItemClick,
  isFilesImporterNewLayout,
}) => {
  const dataHookId = useMemo(() => {
    try {
      return JSON.parse(item.id).id ?? item.id; // import from site actually has JSON in item id
    } catch {}
    return item.id;
  }, [item.id]);

  return (
    <div className={classnames(styles.itemWrapper, { [styles.itemWrapperNewLayout]: true })} key={item.id}>
      <LassoItem itemId={dataHookId}>
        {isFile(item) ? (
          isItemDisabled(item) ? (
            <Tooltip content={<FormattedMessage id="files-importer.purchased-file.prohibit-share.tooltip" />}>
              <ReadonlyFile
                item={item}
                onClick={onItemClick}
                onDoubleClick={onFileDoubleClick}
                isSelected={isItemSelected(item.id)}
                isDisabled={true}
                dataHookId={dataHookId}
              />
            </Tooltip>
          ) : (
            <ReadonlyFile
              item={item}
              onClick={onItemClick}
              onDoubleClick={onFileDoubleClick}
              isSelected={isItemSelected(item.id)}
              isDisabled={false}
              dataHookId={dataHookId}
            />
          )
        ) : (
          <ReadonlyFolder
            item={item as MediaManagerSDKFolder}
            onClick={onItemClick}
            onDoubleClick={onFolderDoubleClick}
            isSelected={isItemSelected(item.id)}
            isFilesImporterNewLayout={isFilesImporterNewLayout}
            dataHookId={dataHookId}
          />
        )}
      </LassoItem>
    </div>
  );
};

export const FilesGallery: FC<IOuter> = ({
  items,
  isItemSelected,
  isItemDisabled,
  onFileDoubleClick,
  onFolderDoubleClick,
  clearItemsSelection,
  onItemClick,
  isFilesImporterNewLayout,
}) => (
  <div className={classnames(styles.wrapper, { [styles.wrapperNewLayout]: true })} onMouseDown={clearItemsSelection}>
    {map(
      (item) => (
        <FilesGalleryItem
          item={item}
          isItemSelected={isItemSelected}
          isItemDisabled={isItemDisabled}
          onFileDoubleClick={onFileDoubleClick}
          onFolderDoubleClick={onFolderDoubleClick}
          onItemClick={onItemClick}
          isFilesImporterNewLayout={isFilesImporterNewLayout}
        />
      ),
      items,
    )}
  </div>
);
